<template>
  <div>
    <answer-render ref="answer" :config="config[questionIndex]">
      <div slot="head">
        <!-- <answer-desc-list
          :config="config"
          optionKey="optionName"
          optionValueKey="id"
          :answerValidate="answerValidate"
          :multiple="true"
        ></answer-desc-list> -->
        <answer-group-table
          :config="config"
          optionKey="optionName"
          optionValueKey="id"
          :answerValidate="answerValidate"
          :multiple="true"
          :questionIndex="questionIndex"
        ></answer-group-table>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
export default {
  name: 'CheckBoxGroupAnswerPc',
  props: ['config', 'questionIndex'],
  data () {
    return {
      answerValidate
    }
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/editor/CheckBoxGroup/CheckBoxGroupAnswerPc.vue